// test1297
(1297 && 0);
